import React, { Component } from 'react';

import AccountCircle from '@mui/icons-material/AccountCircle';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Container,
  TextField,
  MenuItem,
  FormControl,
  Typography,
  Select,
  CssBaseline,
  Box,
  Avatar,
  InputLabel,
  Stack,
} from '@mui/material';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { logUserIn } from '../../../actions';
import i18n from '../../../helpers/i18nMain';

const systemIPOptions = [
  {
    value: 'http://10.33.0.21:50000/sap/opu/odata/sap',
    label: i18n.t('authScreenTranslations:DEV'),
    systemName: 'Development',
    clientOtp: [
      {
        label: '100',
        value: '100',
      },
    ],
  },
  {
    id: 5,
    value: 'https://stoplight.io/mocks/globalintelli/intellisoft:main/14564293',
    label: i18n.t('authScreenTranslations:MOCK'),
    systemName: 'Mock',
    clientOtp: [
      {
        label: '100',
        value: '100',
      },
    ],
  },
];
const environmentVariables = {
  clientOptions: [
    {
      label: '100',
      value: `100`,
    },
  ],
  client: '100',
  systemIP: 'http://10.33.0.21:50000/sap/opu/odata/sap',
  system: i18n.t('authScreenTranslations:DEV'),
  environment: 'Development',
};
class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      client: environmentVariables.client,
      system: environmentVariables.system,
      clientOptions: environmentVariables.clientOptions,
      systemIP: environmentVariables.systemIP,
      // environment: environmentVariables.environment,
      systemName: environmentVariables.environment,
      requestSubmitted: false,
    };
  }

  handleChange = e => {
    this.setState({ client: e.target.value });
  };

  handleChangeSystem = e => {
    try {
      const system = systemIPOptions.find(s => s.label === e.target.value);
      this.setState({
        systemIP: system.value,
        clientOptions: system.clientOtp,
        client: system.clientOtp[0].value,
        system: system.label,
        systemName: system.systemName,
      });
    } catch (error) {
      console.log(error);
    }
  };

  setRequestStatus = requestSubmitted => {
    this.setState(prevState => ({
      ...prevState,
      requestSubmitted,
    }));
  };

  signin = () => {
    try {
      const { username, password, client, systemIP, system, systemName } = this.state;
      this.setState({ requestSubmitted: true });
      this.props.logUserIn(
        { username, password, systemIP, client, system, systemName },
        this.setRequestStatus,
        this.props.enqueueSnackbar
      );
    } catch (error) {
      console.log('error at signin', error);
      this.setState({ requestSubmitted: false });
    }
  };

  renderLogIn = () => {
    const { t } = this.props;
    const { username, password, client, clientOptions, system } = this.state;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <AccountCircle />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t('authScreenTranslations:SIGNIN')}
          </Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              sx={{ mb: 2 }}
              margin="normal"
              fullWidth
              name="username"
              label={t('authScreenTranslations:USERNAME')}
              value={username}
              onChange={e => this.setState({ username: e.target.value })}
            />
            <TextField
              sx={{ mb: 3 }}
              margin="normal"
              fullWidth
              name="password"
              label={t('authScreenTranslations:PASSWORD')}
              type="password"
              value={password}
              onChange={e => this.setState({ password: e.target.value })}
            />
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel> {t('authScreenTranslations:SYSTEM')}</InputLabel>
              <Select
                label={t('authScreenTranslations:SYSTEM')}
                value={system}
                onChange={this.handleChangeSystem}
              >
                {systemIPOptions.map(item => (
                  <MenuItem value={item.label}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>{t('authScreenTranslations:CLIENT')}</InputLabel>
              <Select
                value={client}
                label={t('authScreenTranslations:CLIENT')}
                onChange={this.handleChange}
              >
                {clientOptions.map(item => (
                  <MenuItem value={item.value}>{item.value}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
              <Typography className="t-title" onClick={() => this.props.history.push('/signup')}>
                {t('authScreenTranslations:SIGNUP')}
              </Typography>
              <Typography
                className="t-title"
                onClick={() => this.props.history.push('/forgotpassword')}
              >
                {t('authScreenTranslations:FORGOT_PASS')}
              </Typography>
            </Stack>
            <LoadingButton
              loading={this.state.requestSubmitted}
              fullWidth
              variant="contained"
              sx={{ mt: 1, mb: 2 }}
              onClick={this.signin}
            >
              {t('authScreenTranslations:SIGNIN')}
            </LoadingButton>
          </Box>
        </Box>
      </Container>
    );
  };

  render() {
    const { location, auth } = this.props;
    const { loggedIn } = auth;

    return loggedIn ? (
      <Redirect to={{ pathname: '/', state: { from: location } }} />
    ) : (
      this.renderLogIn()
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const cSignin = connect(mapStateToProps, {
  logUserIn,
})(Signin);
const tSignin = withTranslation(['authScreenTranslations'])(cSignin);
const sSignin = withSnackbar(tSignin);

export { sSignin as Signin };
